import React from 'react';
import './ReadinessSummary.css';

// Plain-language readiness distribution — the SAME readiness semantics the
// student portal already uses, never a new formula (docs/UI_UX_ARCHITECTURE.md
// Admin Phase 5 §5). `levels`: [{ key, label, count, tone }]. Callers map
// their own backend shape (dashboard's readiness_levels, a batch's by_level,
// etc) into this generic shape — the mapping itself lives with the caller so
// this component stays a pure presentational primitive.
const ReadinessSummary = ({ levels, total }) => {
  const max = Math.max(1, ...levels.map(l => l.count));
  return (
    <div className="rs-root">
      {levels.map(l => (
        <div className="rs-row" key={l.key}>
          <span className="rs-label">{l.label}</span>
          <div className="rs-track"><div className={`rs-fill rs-fill--${l.tone}`} style={{ width: `${(l.count / max) * 100}%` }} /></div>
          <span className={`rs-val rs-val--${l.tone}`}>{l.count}</span>
        </div>
      ))}
      {total != null && <p className="rs-total">{total} student{total === 1 ? '' : 's'} total</p>}
    </div>
  );
};

export default ReadinessSummary;
